module.exports = "/fonts/glyphicons-halflings-regular.svg";